export default __webpack_public_path__ + "static/media/row.7e81f37b.jpg";